import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../../ampli';
import { useCheckUserLoggedIn } from '../../../../hooks/user/useCheckUserLoggedIn';

export const GoToJoinSection = () => {
  const navigate = useNavigate();
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return (
    <Container>
      <Title>{'추가 할인된 최저가와\n장기 할부 상담이 필요하다면?'}</Title>
      <JoinButton
        onClick={() => {
          ampli.홈회원가입버튼클릭();
          navigate(isUserLoggedIn ? '/myinfo' : '/oauth/login');
        }}
      >
        <ButtonText>{'회원 가입'}</ButtonText>
      </JoinButton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 16px;

  padding: 0px 16px 40px 16px;
`;

const Title = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Body/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 30px */
`;

const JoinButton = styled.button`
  display: flex;
  width: 167px;
  max-height: 40px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: var(--radius-medium, 8px);
  background: var(--light-scheme-color-primary-blue, #445eff);
`;

const ButtonText = styled.span`
  color: var(--light-scheme-monochrome-white, #fff);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
